import { types } from "../actions";

const initialState = {
  widgets: [],
  fetchErrorMessage: "",
  loading: true,
  hash: "",
  contentFilters: [],
  tagBaseline: [],
  statisticsSelection: null,
};

const statisticsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_WIDGET_SUCCESS": {
      return {
        ...state,
        widgets: action.widgets,
        loading: false,
      };
    }
    case "FETCH_WIDGET_ERROR": {
      return {
        ...state,
        fetchErrorMessage: action.errorMsg,
        loading: false,
      };
    }
    case "FETCH_KNOWI_HASH_SUCCESS": {
      return {
        ...state,
        hash: action.encryptedContent,
        loading: false,
      };
    }
    case "FETCH_KNOWI_HASH_ERROR": {
      console.log("actions", action);
      return {
        ...state,
        fetchErrorMessage: action.errorMsg,
        loading: false,
      };
    }
    case "SET_LOADING_KNOWI": {
      return {
        ...state,
        loading: action.loading,
      };
    }

    case "SET_ALL_BASELINEDATA": {
      return {
        ...state,
        tagBaseline: action.payload,
      };
    }

    case "UPDATE_BASELINE_INFO": {
      let oldTagBaseline = [];
      oldTagBaseline = state?.tagBaseline?.filter((obj) => obj?.id !== action?.payload?.id);
      oldTagBaseline.push(action.payload);
      return{
        ...state,
        tagBaseline: oldTagBaseline,
      }
    }

    case types.SET_STATISTICS_SELECTION: {
      return {
        ...state,
        statisticsSelection: action.payload,
      };
    }

    case types.CLEAR_STATISTICS_SELECTION: {
      return {
        ...state,
        statisticsSelection: null,
      };
    }

    default:
      return state;
  }
};
export default statisticsReducer;
